<template>
  <div class="background"></div>
  <RouterView />
  <MusicPlayButton />
  <ErrorModal
    :show-modal="showErrorModal"
    :error-message="errorMessage"
    :secondary-action="errorSecondaryAction"
    :primary-action-text="errorPrimaryActionText"
    @close-modal="showErrorModal = false"
  />
</template>

<script setup>
import { onMounted, ref, provide } from "vue";
import { useGuestStore } from "./stores/guest.store";
import MusicPlayButton from "./components/MusicPlayButton.vue";
import ErrorModal from "./components/ErrorModal.vue";

const guestStore = useGuestStore();
const showErrorModal = ref(false);
const errorMessage = ref("");
const errorSecondaryAction = ref(null);
const errorPrimaryActionText = ref(null);
// Create methods to handle error modal
const showError = (
  message,
  primaryActionText = "Got it!",
  secondaryAction = null
) => {
  errorMessage.value = message;
  showErrorModal.value = true;
  errorPrimaryActionText.value = null;
  errorSecondaryAction.value = null;
  if (secondaryAction) {
    errorSecondaryAction.value = secondaryAction;
  }
  if (primaryActionText) {
    errorPrimaryActionText.value = primaryActionText;
  }
};

const hideError = () => {
  showErrorModal.value = false;
  errorMessage.value = "";
};

// Provide the methods to child components
provide("errorModal", {
  showError,
  hideError,
});

onMounted(async () => {
  await guestStore.loadResponses();
  guestStore.loadGuest();
});
</script>
<style lang="scss">
#app {
  position: relative;
  // min-height: 100vh;
  width: 100%;
}

.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: -1;
  background-image: radial-gradient(
      circle at center,
      rgba(214, 218, 224, 0.2) 10%,
      rgba(214, 218, 224, 0.9) 90%
    ),
    url("./assets/images/vg-bg-5.webp");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
